import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useUserAdminPresencial = create(persist(
    (set) => ({
    userAdminPresencial: {
        dni: '',
    },
    updateUserAdminPresencial: (newUser) => set(() => ({ userAdminPresencial: newUser })),
    closeUserAdminPresencial: () => set(() => ({ userAdminPresencial: { dni: ''} })),
}), {name: 'userAdminPResencial', storage: createJSONStorage(() => sessionStorage) }
))